import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { StratifyDocument } from "@stratify/shared";
import { getDownloadURL, ref } from "firebase/storage";
import { storage } from "../../../../config/firebase";

interface PreviewTabProps {
  document: StratifyDocument;
}

export const PreviewTab: React.FC<PreviewTabProps> = ({ document }) => {
  const [fileUrl, setFileUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getPreviewUrl = async () => {
      setLoading(true);
      try {
        const storageRef = ref(storage, document.storageLocation);
        const url = await getDownloadURL(storageRef);
        setFileUrl(url);
        setError(null);
      } catch (error) {
        console.error("Error getting download URL:", error);
        setError("Unable to load preview");
        setFileUrl(null);
      } finally {
        setLoading(false);
      }
    };

    getPreviewUrl();
  }, [document.storageLocation]);

  return (
    <Box
      sx={{
        width: "100%",
        maxHeight: "100%",
        flex: 1,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <CircularProgress />
        </Box>
      ) : fileUrl ? (
        <iframe
          src={fileUrl}
          style={{ width: "100%", border: "none", flex: 1 }}
          title="Document Preview"
        />
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Typography color="error">
            {error || "Unable to load preview"}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
